export default __webpack_public_path__ + "static/media/quizz_app_vanillaJS.026ac96f.PNG";